import { ForecastService } from "./services/forecastService";

(function (module) {
    "use strict";
    module.controller('ForecastListCtrl', ['imsLatestData', ForecastService.componentName, '$state', ForecastListCtrl]);

    function ForecastListCtrl(
        this: $TSFixMe,
        imsLatestData: $TSFixMe,
        forecastService: ForecastService,
        $state: ng.ui.IStateService
    ) {
        var $ctrl = this;

        $ctrl.imsLatestData = imsLatestData;
        $ctrl.$state = $state;
        $ctrl.createNewForecast = function () {
            $ctrl.promiseHandler = forecastService.create().then(function (forecastId: $TSFixMe) {
                $state.go('forecast.edit', { id: forecastId });
            });
        }
    }

})(angular.module('topline.modules'));

